import React, { useCallback } from 'react';
import styled from 'styled-components/macro';
import { ToolsItem } from 'components/Tools/ToolsItem/ToolsItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { IMobileSide, StyledMobileSide } from 'components/MobileSide/MobileSide';
import { topicsData } from 'config/topics';
import { Paragraph } from 'components/Paragraph/Paragraph';
import { useTypedSelector } from 'redux/reducers';
import { useDispatch } from 'react-redux';
import { updateTopic } from 'redux/actions/topicAction';
import { Heading } from 'components/Heading/Heading';
import { useViewport } from 'hooks/useViewport';
import { theme } from 'theme';

const StyledMobileNavigation = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
  z-index: 30;
  background: ${({ theme }) => theme.colors.green};
  display: flex;
  align-items: flex-end;
  padding: ${({ theme }) => `${theme.spacing[1]} ${theme.spacing[.5]}`};

  /* &:before {
    content: '';
    display: block;
    background: ${({ theme }) => theme.colors.green};
    padding: 40px;
    position: absolute;
    width: 640px;
    height: 640px;
    left: 0;
    bottom: 0;
    transform: translate(-50%, 50%);
    border-radius: ${({ theme }) => theme.radius.full};
    z-index: -1;
  } */
`;

const StyledMobileNavigationSide = styled(StyledMobileSide)`
  justify-content: flex-end;
`;

const StyledMobileNavigationMain = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacing[4]} 0`};
  flex: 1;
`;

const StyledMobileNavigationList = styled.ul`
  display: flex;
  margin: ${({ theme }) => `-${theme.spacing[1]}`};
  max-width: 100%;
  flex-wrap: wrap;
  flex-direction: row;
`;

const StyledMobileNavigationItem = styled.li`
  padding: ${({ theme }) => `${theme.spacing[1]}`};
  list-style-type: none;
  align-self: center;
  display: inline-flex;
`;

const StyledMobileNavigationButton = styled.button<{ active: boolean }>`
  font-weight: bold;
  border: none;
  border-radius: ${({ theme }) => theme.radius.sm};
  background: ${({ theme, active }) => theme.colors[active ? 'black' : 'white']};
  color: ${({ theme, active }) => theme.colors[active ? 'white' : 'black']};
  display: flex;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing[1]} ${theme.spacing[1.5]}`};

  > * + * {
    margin-left: ${({ theme }) => `${theme.spacing[1]}`};
  }
`;

const StyledMobileNavigationParagrahp = styled(Paragraph)`
  line-height: 1;
`;

export const NavigationMobile: React.FC<IMobileSide> = ({ onMenuClick }) => {
  const activeTopic = useTypedSelector((state) => state.topic.selected);
  const dispatch = useDispatch();
  const { width } = useViewport();

  const handleNavItemClick = useCallback((id: number) => () => {
    dispatch(updateTopic(topicsData[id]));
    onMenuClick();
  }, [dispatch, onMenuClick]);

  return (
    <StyledMobileNavigation>
      <StyledMobileNavigationSide>
        <ToolsItem
          title="Menu"
          onClick={onMenuClick}
          icon={<FontAwesomeIcon size="lg" icon={faTimes} />}
          invert
        />
      </StyledMobileNavigationSide>
      <StyledMobileNavigationMain>
        <Heading as="h2">CZO Interactive</Heading>
        <StyledMobileNavigationList>
          {topicsData.map(({ label, id, icon: Icon }) => label && (
            <StyledMobileNavigationItem key={id}>
              <StyledMobileNavigationButton active={activeTopic.id === id} onClick={handleNavItemClick(id)} >
                {width > theme.breakpoints.sm && <Icon width={20} height={20} />}
                <StyledMobileNavigationParagrahp size="introduction">{label}</StyledMobileNavigationParagrahp>
              </StyledMobileNavigationButton>
            </StyledMobileNavigationItem>
          ))}
        </StyledMobileNavigationList>
      </StyledMobileNavigationMain>
    </StyledMobileNavigation>
  );
};